import { zod } from '@acme/core'
import { z } from 'zod'

import ApiService from '../api.service'

export type ExcecaoRubrica = z.infer<typeof zod.ExcecaoRubricaSchema>
export type Rubrica = z.infer<typeof zod.RubricaSchema> & {
    ExcecaoRubrica?: ExcecaoRubrica[]
}

export const createRubricaSchema = zod.RubricaSchema.omit({
    updatedAt: true,
    createdAt: true,
}).partial({
    id: true,
    clienteId: true,
})

export const updateRubricaSchema = createRubricaSchema.required({
    id: true,
    clienteId: true,
})

export const upsertExcecaoRubricaSchema = zod.ExcecaoRubricaSchema.omit({
    createdAt: true,
    updatedAt: true,
})

const service = new ApiService<Rubrica>('rubricas')

const excecao = new ApiService<
    Omit<ExcecaoRubrica, 'createdAt' | 'updatedAt' | '__typename'>
>('rubricas/excecao')

export const rubrica = Object.assign(service, {
    excecao,
})
